import _ from '@lodash';
import 'ag-grid-enterprise';
import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AgGridReact} from 'ag-grid-react';
import { Button } from '@material-ui/core';
import 'ag-grid-enterprise/styles/ag-grid.css';
import 'ag-grid-enterprise/styles/ag-theme-material.css';
import 'styles/ag-grid-header-style.css';
import axios from "@fuse/utils/axios";
import { useDispatch } from 'react-redux';
import useRouter from '@fuse/hooks/useRouter';
import NumberFilter from '../Filters/numberFilter';
import TextFilter from '../Filters/textFilter';
import { setfilterlist, setrowGroupModel } from '../store/filterParamsReducer';

const useStyles = makeStyles({
	layoutRoot: {},
	head: {
		position: "sticky",
		top: 0
	},
	root: {
		// minWidth: 275,
	},
	title: {
		fontSize: 14,
	},
	pos: {
		marginBottom: 12,
	},
	searchbar: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		margin:'5px 5px 5px 0',
		height:'28px',
	},
	buttonSquare : {
		borderRadius:'5px'
	}	
});

function ListView(props) {
    const classes = useStyles();	
	const [gridApi,setGridApi] = useState(null);
	const rowGroupPanelShow = 'always';
	const table_name = 'INVOICE';
	const [displayButton,setDisplayButton] = useState(false);
	const [windowHeight,setWindowHeight] = useState(window.innerHeight-320);
	const dispatch = useDispatch();
	const router = useRouter();

	const onGridReady = (params) => {
		setGridApi(params);		
		if(router.query.report_name === undefined) {			
			loadInitialState(params);
			dispatch(setfilterlist({}));
			dispatch(setrowGroupModel([]));
		}else{
			getReport(params);
		}
	}

	const onColumnMoved = (params) =>{
		if(router.query.report_name === undefined) {
			const rows = params.api.getColumnState();
			saveView (rows);
		}
	}

	const onColumnPinned = (params) =>{
		if(router.query.report_name === undefined) {
			const rows = params.api.getColumnState();
			saveView (rows);
		}
	}

	function onColumnVisible(params){
		const rows = params.api.getColumnState();
		const total_no_of_columns = rows.length;
		let total_hidden_columns = 0;
		rows.forEach(row=>{
			const { hide } = row;
			if(hide) {
				++total_hidden_columns;
			}
		});
		if( total_hidden_columns < total_no_of_columns){
			if(router.query.report_name === undefined) {
				saveView(rows)
			}
		}
	}

	const onGridSizeChanged  = () =>{
		setWindowHeight(window.innerHeight - 320);
	}

	const onRangeSelectionChanged = (params) => {
		if(params.finished === true){
			setDisplayButton(true);
		}
		if(params.api.getCellRanges() === 0 ){
			setDisplayButton(false);
		}
	}

	const clearSelection = () =>{
		gridApi.api.clearRangeSelection();
	}

	function onFilterChanged(event){

		const rows = event.api.getFilterModel();
		dispatch(setfilterlist(rows));

		// validation for no-overlay 
		const total_rows = event.api.getDisplayedRowCount();
		if(total_rows === 0 ){
			event.api.showNoRowsOverlay();
		}else{
			event.api.hideOverlay();
		}
	}

	function onColumnRowGroupChanged(event){
		if(router.query.report_name === undefined){
			const rows = event.api.getColumnState();
			const first_row = rows[0];
			if(first_row.colId !== 'ag-Grid-AutoColumn'){
				dispatch(setrowGroupModel([]));
				saveView(rows);
			}else{
				dispatch(setrowGroupModel(rows));
			}
		}
		onRowGroupOpenedAutoSize();
	}

	function getReport(event){
		const {report_name} = router.query;
		const table_name = "invoices";
		axios.get(`/reports/view-report?table_name=${table_name}&report_name=${report_name}`)
		.then(results=>{
			const model = JSON.parse(results.data.data.filter);
			event.api.setFilterModel(model);
			const row_model = JSON.parse(results.data.data.row_model);
			event.api.applyColumnState(row_model);
		})
		.catch(err=>{
			console.log(err);
		})
	}

	function saveView (rows){
        const order = JSON.stringify(rows);
        axios.post('/user-view/save-view-order',{
            table_name,
            order
        })
        .then(()=>{
			console.log('view updated')
        })
        .catch(err=>{
            console.log(err);
        })
    }


	function loadInitialState (params){
        axios.get(`/user-view/show-view-order?table_name=${table_name}`)
        .then(results=>{
			const { data } = results.data;
            const order = JSON.parse(data.order);
            params.api.applyColumnState(order);
        })
        .catch(err=>{
            console.log(err);
        })
    }

	function onRowGroupOpenedAutoSize(){	
		const allColumnIds = [];
		gridApi.api.getColumnState().forEach((column) => {
			// only auto-sizing the auto-generated group column
			if(column.colId === 'ag-Grid-AutoColumn') {
				allColumnIds.push(column.colId);
			}
		});
		gridApi.api.autoSizeColumns(allColumnIds, false);
	}

	return (
		<>
			<div className = {classes.searchbar}>
				{
					displayButton && <Button 
						variant="outlined"
						color="secondary" 
						size="small"
						className = {classes.buttonSquare}
						onClick = {()=>clearSelection()}
					>
						Clear range selection
					</Button>
				}
			</div>
			<div className="ag-theme-material" style={{height: windowHeight, width: "100%"}}>
				<AgGridReact
					onGridReady = { onGridReady }
					animateRows
					
					rowData={props.endUsersAccounts}
					onRowClicked={e => {
						if(e.data !== undefined){
							props.gotoDetailsPage(e.data.id)
						}

					}}

					// custom floating filter for design change
					components={{
						customTextFloatingFilter: TextFilter,
						customNumberFloatingFilter : NumberFilter
					}}

					// Conditions for row grouping
					showOpenedGroup
					suppressDragLeaveHidesColumns
					suppressMakeColumnVisibleAfterUnGroup
					autoGroupColumnDef={{ minWidth: 200 }}
					rowGroupPanelShow={ rowGroupPanelShow }

					onColumnMoved = { onColumnMoved }
					onColumnPinned = { onColumnPinned }
					onColumnVisible = { onColumnVisible }

					// status bar enabled on selection of multiple rows 						
					enableRangeSelection
					statusBar={{
						statusPanels: [
						{ 
							statusPanel: 'agAggregationComponent' },
						],
					}}

					// for updating the table height on different window size
					onGridSizeChanged = { onGridSizeChanged }

					// to check the the no. of rows selected during range selection
					onRangeSelectionChanged = { onRangeSelectionChanged }
					
					overlayNoRowsTemplate="<span>No Result Found</span>"
					onFilterChanged = { onFilterChanged }	

					onColumnRowGroupChanged = { onColumnRowGroupChanged }

					// on row grid opened
					onRowGroupOpened={onRowGroupOpenedAutoSize}
					columnDefs={Object.keys(props.endUsersAccounts[0]).filter((item) => item !== 'id').map(header => {
						return {
							field: header,
							key: header,
							headerName: header.split('_').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' '),
							sortable: true,
							floatingFilter: true,
							filter: "agTextColumnFilter"
						}
					})}
					
					 />
			</div>
		</>			
	);
}

export default ListView
